function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SDropdownV3, SField } from "../..";
import { useCallback, useEffect, useRef, useState } from "react";
import _ from "lodash";
export const DrawerPropertyEditor = ({ value, onChangeValue, readOnly, onClickValue })=>{
    const [activeIndex, setActiveIndex] = useState(0);
    const [startingPercentage, setStartingPercentage] = useState(undefined);
    const [sliderWidth, setSliderWidth] = useState(0);
    const sliderBackgroundRef = useRef(null);
    const { mouseDown, offset } = useMouseOffset();
    const setProps = (newProps)=>{
        const props = {
            type: "property-drawer",
            dismissible: true,
            detents: (value === null || value === void 0 ? void 0 : value.detents) || [],
            backgroundInteractive: false
        };
        onChangeValue === null || onChangeValue === void 0 ? void 0 : onChangeValue(_object_spread({}, props, value, newProps));
    };
    useEffect(()=>{
        const newPercentage = _.clamp((startingPercentage || 0) + Math.round(offset.x / sliderWidth * 10000) / 100, 0, 100);
        if (activeIndex !== undefined && !isNaN(newPercentage) && (value === null || value === void 0 ? void 0 : value.detents)) {
            const newDetents = value.detents.map((point, i)=>{
                if (i === activeIndex) {
                    return _object_spread_props(_object_spread({}, point), {
                        value: newPercentage.toString()
                    });
                }
                return point;
            });
            setProps({
                detents: newDetents
            });
        }
    }, [
        offset
    ]);
    useEffect(()=>{
        if (sliderBackgroundRef.current) {
            setSliderWidth(sliderBackgroundRef.current.offsetWidth);
        }
    }, [
        sliderBackgroundRef.current
    ]);
    const detents = (value === null || value === void 0 ? void 0 : value.detents) || [];
    return /*#__PURE__*/ _jsx("div", {
        onClick: onClickValue,
        children: /*#__PURE__*/ _jsx("div", {
            className: readOnly ? "pointer-events-none" : "",
            children: /*#__PURE__*/ _jsx(SField, {
                children: /*#__PURE__*/ _jsx("div", {
                    className: "flex flex-col gap-2 pl-2",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "grid grid-cols-2 gap-3 items-center",
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                children: "Dismissible"
                            }),
                            /*#__PURE__*/ _jsx(SDropdownV3, {
                                borderless: false,
                                options: [
                                    {
                                        label: "Using gestures",
                                        value: "TRUE"
                                    },
                                    {
                                        label: "Manually",
                                        value: "FALSE"
                                    }
                                ],
                                value: (value === null || value === void 0 ? void 0 : value.dismissible) ? "TRUE" : "FALSE",
                                onChange: (transition)=>{
                                    setProps({
                                        dismissible: transition.value === "TRUE"
                                    });
                                }
                            })
                        ]
                    })
                })
            })
        })
    });
};
const useMouseOffset = ()=>{
    const [offset, setOffset] = useState({
        x: 0,
        y: 0
    });
    const [startPosition, setStartPosition] = useState({
        x: 0,
        y: 0
    });
    const [isTracking, setIsTracking] = useState(false);
    const mouseDown = useCallback((event)=>{
        setIsTracking(true);
        setStartPosition({
            x: event.clientX,
            y: event.clientY
        });
    }, []);
    const mouseUp = useCallback(()=>{
        setIsTracking(false);
        setStartPosition({
            x: 0,
            y: 0
        });
    }, []);
    useEffect(()=>{
        const onMouseMove = (event)=>{
            if (!isTracking) return;
            const offsetX = event.clientX - startPosition.x;
            const offsetY = event.clientY - startPosition.y;
            setOffset({
                x: offsetX,
                y: offsetY
            });
        };
        if (isTracking) {
            window.addEventListener("mousemove", onMouseMove);
            window.addEventListener("mouseup", mouseUp);
        } else {
            window.removeEventListener("mousemove", onMouseMove);
            window.removeEventListener("mouseup", mouseUp);
        }
        return ()=>{
            window.removeEventListener("mousemove", onMouseMove);
            window.removeEventListener("mouseup", mouseUp);
        };
    }, [
        isTracking
    ]);
    return {
        offset,
        mouseDown
    };
};
